var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboards-viewer" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isList
            ? [
                _c(
                  "div",
                  { staticClass: "dashboards-viewer__card-grid" },
                  _vm._l(_vm.dashboards, function(ref) {
                    var uid = ref.id
                    var attributes = ref.attributes
                    return _c(
                      "ListCard",
                      _vm._b(
                        {
                          key: uid,
                          nativeOn: {
                            click: function($event) {
                              return _vm.handleClick(uid)
                            }
                          }
                        },
                        "ListCard",
                        attributes,
                        false
                      )
                    )
                  }),
                  1
                )
              ]
            : _vm.currentDashboard
            ? [_c("Viewer", { attrs: { config: _vm.currentDashboard } })]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.showBackBtn
        ? _c(
            "span",
            {
              staticClass: "dashboards-viewer__button",
              on: { click: _vm.handleClick }
            },
            [
              _c("i", { staticClass: "fas fa-arrow-left" }),
              _vm._v(" " + _vm._s(_vm.backLabel) + "\n  ")
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }